import { combineReducers } from 'redux';

import replyToMessage from './replyToMessage/reducer';
import teamMessage from './teamMessage/reducer';

export default combineReducers({
  replyToMessage,
  teamMessage
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/textEditing/reducer.js
 **/